@let corporateDesign = corporateDesignService.corporateDesign();
@let fontColor =
  corporateDesignService.isDarkModeActive()
    ? corporateDesign.colorAdmixtures.dark_text_high
    : corporateDesign.primaryColor;
@if (corporateDesign) {
  <aw-section
    [testIdAffix]="id()"
    [darkModeColor]="corporateDesign.colorAdmixtures.dark_surface_01">
    <aw-extendable-text
      #extendableText
      [id]="id() | appendTestId: 'extendable'"
      [attr.data-testid]="id() | appendTestId: 'extendable'"
      [titleTemplate]="titleTemplate">
      <ng-template #titleTemplate let-extended="extended" let-toggle="toggle">
        @let topLink = titleLink();
        <nav
          tabindex="0"
          [attr.data-testid]="id() | appendTestId: 'extension-toggle'"
          [routerLink]="topLink"
          (click)="topLink ? onSelect.emit(true) : undefined"
          (keyup.enter)="topLink ? navigate(topLink) : toggle(extended)"
          class="flex w-full flex-row items-center justify-between pb-4 text-xl">
          <span class="flex flex-row items-center">
            <span
              class="material-symbols-rounded min-w-12 text-2xl!"
              [style.color]="fontColor"
              [attr.data-testid]="id() | appendTestId: 'title-icon'">
              {{ icon() }}
            </span>
            <span
              [style.color]="
                corporateDesignService.isDarkModeActive()
                  ? corporateDesign.colorAdmixtures.dark_text_high
                  : '#000000'
              "
              class="w-full"
              [attr.data-testid]="id() | appendTestId: 'title-text'"
              >{{ title() }}</span
            >
          </span>
          @if (links().length > 0) {
            <span
              class="material-symbols-rounded text-3xl!"
              [style.color]="fontColor"
              [attr.data-testid]="id() | appendTestId: 'arrow-icon'">
              {{ extended ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </span>
          }
        </nav>
      </ng-template>
      <ol
        class="-mx-[14px] flex flex-col overflow-x-hidden"
        [attr.data-testid]="id() | appendTestId: 'content'">
        @for (link of links(); track $index; let index = $index) {
          <a
            [attr.data-testid]="id() | appendTestId: 'link-' + index"
            class="hover:text-input-focus cursor-pointer py-2 pl-16 text-xl"
            [ngClass]="{
              'bg-standard-hover-main font-semibold': activeLink() === link,
            }"
            (mouseenter)="menuSelectSupport.highlightedLink.set(index)"
            (mouseleave)="menuSelectSupport.highlightedLink.set(undefined)"
            [style.color]="
              menuSelectSupport.highlightedLink() === index
                ? !corporateDesignService.isDarkModeActive()
                  ? menuSelectSupport.highlightedLinkColor()
                  : corporateDesign.colorAdmixtures.dark_text_high
                : !corporateDesignService.isDarkModeActive()
                  ? ''
                  : corporateDesign.colorAdmixtures.dark_text
            "
            [style.background-color]="determineLinkBackground(link)"
            [routerLink]="link.url"
            (click)="onSelect.emit(true)">
            {{ link.label }}
          </a>
        }
      </ol>
    </aw-extendable-text>
  </aw-section>
}
